import React from 'react';
import styled, { keyframes } from 'styled-components';
import logo from '../../logo.svg'; // Ajuste o caminho se sua logo estiver em 'src/assets/logo.svg'

// Animação de pulsar (aumentar e diminuir suavemente)
const pulse = keyframes`
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.1); opacity: 0.8; }
  100% { transform: scale(1); opacity: 1; }
`;

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.background || '#f4f6f8'}; // Usa cor do tema ou fallback
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999; // Garante que fique acima de tudo
`;

const LogoImage = styled.img`
  width: 120px; // Ajuste o tamanho inicial conforme necessário
  height: auto;
  animation: ${pulse} 2s infinite ease-in-out;
  margin-bottom: 1.5rem;
`;

const LoadingText = styled.p`
  color: ${({ theme }) => theme.colors.secondary || '#333'};
  font-size: 1.1rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  animation: ${pulse} 2s infinite ease-in-out; // O texto também pulsa suavemente
`;

const LoadingScreen = ({ message = "Carregando..." }) => {
  return (
    <Container>
      <LogoImage src={logo} alt="Escuta Logo" />
      <LoadingText>{message}</LoadingText>
    </Container>
  );
};

export default LoadingScreen;